import * as React from "react";
import { Infobar } from "../Infobar/Infobar";
import { StyledModal } from "../StyledModal/StyledModal";

interface IAValueInfoModalProps {
  onDismiss(): void;
  activeView?:'avvikelse' | 'noll'
}

const AValueInfoModal: React.FunctionComponent<IAValueInfoModalProps> = (
  props
) => {
  return (
    <StyledModal
      title={"Info om A.Värde"}
      onDismiss={() => {
        props.onDismiss();
      }}
      body={
        <div>
          {props?.activeView && props.activeView == 'noll' ? (<>
          <h5>Nollrapportering – hur avvikelsen beräknas</h5>

<p>
  Den här kontrollen används för leverantörer som historiskt ofta rapporterar
  <b>0 kr</b>.
</p>

<h6>Så fungerar beräkningen</h6>
<ul>
  <li>Vi tittar på leverantörens historik bakåt i tiden (minst <b>12 månader</b>).</li>
  <li>Varje månad där den rapporterade summan är <b>0 kr</b> räknas som en nollmånad.</li>
  <li>Saknas data för en månad betraktas den som <b>0 kr</b>.</li>
</ul>

<h6>Nollgrad (A-värde)</h6>
<ul>
  <li>
    Nollgraden visar hur stor andel av historiken som består av nollmånader.
  </li>
  <li>
    Exempel: 9 nollmånader av 12 → <b>75&nbsp;% nollgrad</b>
  </li>
</ul>

<h6>Flaggning (OK / Gul / Röd)</h6>
<ul>
  <li>Varje leverantör kan ha egna tröskelvärden.</li>
  <li>
    <b>Röd</b> flagga sätts om nollgraden når röd tröskel.
  </li>
  <li>
    <b>Gul</b> flagga sätts om nollgraden når gul tröskel.
  </li>
  <li>
    <b>OK</b> visas om nollgraden ligger under trösklarna.
  </li>
  <li>
    Saknas trösklar visas status <b>Ingen tröskel</b>.
  </li>
</ul>

<h6>Viktigt att veta</h6>
<ul>
  <li>
    Bedömningen baseras på <b>historiskt nollbeteende</b>, inte bara aktuell månad.
  </li>
  <li>
    En leverantör kan därför flaggas även om belopp rapporterats i vald period.
  </li>
</ul>


<Infobar text={"Tänk på att resultatet är ett beslutsstöd och inte ett definitivt svar."} />

          </>):(
            <>
             <h5>Vart kommer Avvikelsevärdet(A.värde) ifrån?</h5>
          <p>
            <ul>
              <li>A.värde är resultatet av en beräkning från en AI-modell. </li>
              <li>
                Modellen beräknar ut förväntade summor som en leverantör ska
                rapportera för en viss period.
              </li>
              <li>
                Därefter jämförs den förväntade summan med vad leverantören
                faktiskt har rapporterat för respektive period, vilket därefter
                leder till procent-värdet.
              </li>
              <li>
                Om det förväntade värdet är högre än rapporterat blir procenten
                positiv, medans den blir negativ om rapporterat är högre.
              </li>
              <li>
                Den förväntade summan tas fram av modellen baserat på historisk
                rapportering.
              </li>
            </ul>
          </p>
          <p>
            Här är ett förenklat exempel på framtagandet av procentvärdet:
            <br />
            <div
              style={{
                padding: "12px",
                border: "1px solid #8c8b8b",
                borderRadius: "5px",
                background: "#f4f4f4",
                color: "#8c8b8b",
                fontSize: "14px",
              }}
            >
              Inrapporterad summa = 80 000
              <br />
              Förväntad summa = 100 000
              <br />
              Förväntad / Inrapporterad = 1.25
              <br />
              Skillnad = 0.25 (1.25 - 1)
              <br />
              Procent = 25%
            </div>
          </p>
          <Infobar
            text={"Tänk på att resultatet inte är ett definitivt svar!"}
          />
            </>
          )}
         
        </div>
      }
    />
  );
};

export default AValueInfoModal;
